import React, { Component } from 'react';
import { FORMAT_NUMBER, CURRENCY, SYMBOL } from '../libs/utils/Const';
import $ from 'jquery';
import '../css/ticket.css';

class RefundTicketModal extends Component {

    componentDidMount() {
        this.closeAction();
    }

    closeAction = () => {
        const { CloseBillModal } = this.props;
        $('#refundTicketModal').on('hidden.bs.modal', function () {
            CloseBillModal(true);
        });
    };

    render() {
        const { newOrderModel, Print, _user} = this.props;
        return (
            <div className="modal fade" id="refundTicketModal" role="dialog" tabIndex="-1" aria-labelledby="refundTicketModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content" style={{ backgroundColor: "#fff0", border: "none" }}>
                        <div className="modal-body">
                            <div className="ticket" style={{ fontSize: 12 }}>
                                <div className="m-3">
                                    <div className="" >
                                        <div className="text-center" >
                                            <img className="img-fluid d-block mx-auto" src={require('../images/logoTicket.png')} style={{ maxWidth: "200px" }} alt="COUNTER ONE"></img>
                                            <p>{`SUCURSAL: ${_user?.Sucursal.toUpperCase()} `}</p>
                                            <p>{_user?.Branch.Address.toUpperCase()}</p>
                                            <p>N° folio {newOrderModel?.folio ?? ''}</p>
                                        </div>
                                        <br />
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td align="left">{newOrderModel.DocDate}</td>
                                                    <td align="right">{newOrderModel.DocTime}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <br />
                                    <div className='text-center pb-3'>
                                        <span><strong>ARTÍCULOS DEVUELTOS</strong></span>
                                    </div>
                                    <div className="scrollDivDev ">
                                        <div className="pr-2 pl-2">
                                            <table >
                                                <tbody>
                                                    {!!newOrderModel.Items &&
                                                        newOrderModel.Items.map((item, index) => {
                                                            return (
                                                                <>
                                                                <tr key={`ItemTicket3${item.ItemCode}`}>
                                                                    <td>{item.Quantity}</td>
                                                                    <td colSpan={4}>{item.Dscription || item.ItemDescription ||  item.ItemCode ||  '' }</td>
                                                                </tr>
                                                                <tr key={`ItemTicket4${item.ItemCode}`}>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td align="right">{CURRENCY + ' ' + FORMAT_NUMBER.new(item.UnitPrice)}</td>
                                                                    <td width="86px" align="right">{CURRENCY + ' ' + FORMAT_NUMBER.new(item.LineTotal)}</td>
                                                                </tr>
                                                                </>
                                                            )
                                                        })}
                                                </tbody>
                                                <tfoot>

                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>

                                    <br></br>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>Subtotal</td>
                                                <td align="right">{parseFloat(newOrderModel.DocTotal - newOrderModel.VatSum).toFixed(2)}</td>
                                            </tr>
                                            <tr>
                                                <td>I.V.A.</td>
                                                <td align="right">{parseFloat(newOrderModel.VatSum).toFixed(2)}</td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr style={{ fontSize: 16 }}>
                                                <td>Total</td>
                                                <td align="right">{parseFloat(newOrderModel.DocTotal).toFixed(2)}</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                                <div className="text-right" style={{marginTop: "10px"}}>
                                    <button className="btn" onClick={()=>Print("Devolucion", "80", newOrderModel)}><i className="fa fa-print" aria-hidden="true" style={{fontSize: "25px", color: "#80808073"}}></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default RefundTicketModal;